import { v4 as uuidv4 } from 'uuid';
import { FieldJump } from 'queries';
import { LogicJumpOption } from '../FormBuilder/elements/interface';

export const updateLogicJumpWithDefaultAction = (
  fieldId: string,
  logicJumpOption: LogicJumpOption,
  jumps: FieldJump[] = [],
): FieldJump[] => {
  const defaultJump = jumps.find((jump) => !jump.conditionChoiceRefs) || {};
  const res = jumps.filter((jump) => !!jump.conditionChoiceRefs);

  const newDefault = {
    id: uuidv4(),
    ...defaultJump,
    fieldId,
    type: logicJumpOption.type,
    toFieldId: logicJumpOption.toFieldId,
    conditionChoiceRefs: undefined,
  };
  res.push(newDefault);
  return res;
};
